import { useEffect, useRef } from 'react';
import { useUser } from '@/hooks/useUser';
import { useSelector } from 'react-redux';
import { getUi } from '@ducks/ui/selectors';
import { useBraze } from '@/components/Braze';

export const BrazeEvents = () => {
  const { logCustomEvent } = useBraze();
  const { data: user } = useUser();
  const ui = useSelector(getUi);

  const sentUserRegistered = useRef(false);

  useEffect(() => {
    if (ui.showOnboarding && user.id) {
      if (sentUserRegistered.current) {
        return;
      }
      sentUserRegistered.current = true;
      logCustomEvent('user_registered', {
        first_name: user.givenName,
        last_mame: user.familyName,
        email: user.emailAddress,
        default_market: user.defaultMarketISO,
      });
    }
  }, [user, ui, logCustomEvent]);

  return null;
};
